import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';
import PhotoSlotIcon from '../../../../../icons/PhotoSlotIcon';

const propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    cardElementConfiguration: PropTypes.shape({
      asset_image: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    frame: {
      width: PropTypes.number,
      height: PropTypes.number,
    },
  }),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerCardElementPhoto = ({ element, className, onClick }) => {
  const { cardElementConfiguration } = element;
  const { asset_image: assetImage } = cardElementConfiguration ?? {};
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-photo': true,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      {!assetImage && (
        <CardDesignerCardElementPlaceholder icon={<PhotoSlotIcon />} />
      )}
    </a>
  );
};

CardDesignerCardElementPhoto.propTypes = propTypes;

export default CardDesignerCardElementPhoto;
